import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';
import { superadminGuard } from './core/auth/superadmin.guard';
import { adminGuard } from './core/auth/admin.guard';
import { memberGuard } from './core/auth/member.guard';
import { AppShellComponent } from './shared/components/layout/app-shell/app-shell.component';

const loadResearchDataset = () =>
  import('./pages/research-dataset/research-dataset.component').then(m => m.ResearchDatasetComponent);

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    title: 'Login',
  },
  {
    path: '',
    component: AppShellComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'research/dataset/overview', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        title: 'Dashboard',
              canActivate: [superadminGuard],
      },
      {
        path: 'jobs/:id',
        loadComponent: () => import('./pages/job-detail/job-detail.component').then(m => m.JobDetailComponent),
        title: 'Job Details',
              canActivate: [superadminGuard],
      },
      {
        path: 'destinations',
        loadComponent: () => import('./pages/destinations/destinations.component').then(m => m.DestinationsComponent),
        title: 'Destinations',
              canActivate: [adminGuard],
      },
      {
        path: 'reviews',
        loadComponent: () => import('./pages/review-destinations/review-destinations.component').then(m => m.ReviewDestinationsComponent),
        title: 'Reviews',
              canActivate: [memberGuard],
      },
      {
        path: 'settings',
        loadComponent: () => import('./pages/scraper-settings/scraper-settings.component').then(m => m.ScraperSettingsComponent),
        title: 'Scraper Settings',
              canActivate: [superadminGuard],
      },
      {
        path: 'settings/llm',
        loadComponent: () => import('./pages/llm-config/llm-config.component').then(m => m.LlmConfigComponent),
        title: 'Konfigurasi LLM',
        canActivate: [superadminGuard],
      },
      {
        path: 'categories',
        loadComponent: () => import('./pages/categories/categories.component').then(m => m.CategoriesComponent),
        title: 'Categories',
              canActivate: [adminGuard],
      },
      {
        path: 'research/dataset',
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'overview' },
          { path: 'overview',      loadComponent: loadResearchDataset, title: 'Dataset & Split — Overview' },
          { path: 'samples',       loadComponent: loadResearchDataset, title: 'Dataset & Split — Samples' },
          { path: 'label-mapping', loadComponent: loadResearchDataset, title: 'Dataset & Split — Label Mapping' },
          { path: 'exports',       loadComponent: loadResearchDataset, title: 'Dataset & Split — Exports' },
          { path: '**', redirectTo: 'overview' },
        ],
      },
      {
        path: 'researches',
        loadComponent: () => import('./pages/researches/researches.component').then(m => m.ResearchesComponent),
        title: 'Penelitian',
              canActivate: [adminGuard],
      },
      {
        path: 'preprocessing',
        loadComponent: () => import('./pages/preprocessing/preprocessing.component').then(m => m.PreprocessingComponent),
        title: 'Preprocessing Pipeline',
              canActivate: [adminGuard],
      },
      {
        path: 'research/lexicon',
        loadComponent: () => import('./pages/research-lexicon/lexicon.component').then(m => m.ResearchLexiconComponent),
        title: 'Lexicon Graph',
              canActivate: [adminGuard],
      },
      {
        path: 'research/emotion-classes',
        loadComponent: () => import('./pages/research-emotion-classes/research-emotion-classes.component').then(m => m.ResearchEmotionClassesComponent),
        title: 'Kelas Emosi',
              canActivate: [adminGuard],
      },
      {
        path: 'research/training',
        loadComponent: () => import('./pages/research-training/research-training.component').then(m => m.ResearchTrainingComponent),
        title: 'Training Eksperimen',
              canActivate: [adminGuard],
      },
      {
        path: 'research/training/new',
        loadComponent: () => import('./pages/research-training-new/research-training-new.component').then(m => m.ResearchTrainingNewComponent),
        title: 'Buat Eksperimen',
              canActivate: [adminGuard],
      },
      {
        path: 'research/training/presets',
        loadComponent: () => import('./pages/research-training-presets/research-training-presets.component').then(m => m.ResearchTrainingPresetsComponent),
        title: 'Training Presets',
              canActivate: [adminGuard],
      },
      {
        path: 'research/training/:id',
        loadComponent: () => import('./pages/research-training-detail/research-training-detail.component').then(m => m.ResearchTrainingDetailComponent),
        title: 'Detail Eksperimen',
              canActivate: [adminGuard],
      },
      {
        path: 'research/comparison',
        loadComponent: () => import('./pages/research-comparison/research-comparison.component').then(m => m.ResearchComparisonComponent),
        title: 'Model Comparison',
              canActivate: [adminGuard],
      },
      {
        path: 'research/inference',
        loadComponent: () => import('./pages/research-inference/research-inference.component').then(m => m.ResearchInferenceComponent),
        title: 'Model Inference',
      },
      {
        path: 'annotator/tasks',
        loadComponent: () => import('./pages/annotator-tasks/annotator-tasks.component').then(m => m.AnnotatorTasksComponent),
        title: 'Tugas Saya',
        canActivate: [memberGuard],
      },
      {
        path: 'annotator/guidelines',
        loadComponent: () => import('./pages/annotator-guidelines/annotator-guidelines.component').then(m => m.AnnotatorGuidelinesComponent),
        title: 'Panduan Anotasi',
        canActivate: [memberGuard],
      },
      {
        path: 'annotators',
        loadChildren: () => import('./pages/annotators/annotators.routes').then(m => m.annotatorRoutes),
        title: 'Annotators',
              canActivate: [memberGuard],
      },
      {
        path: 'emoticons',
        loadComponent: () => import('./pages/emoticons/emoticons.component').then(m => m.EmoticonsComponent),
        title: 'Emoticons',
              canActivate: [memberGuard],
      },
      {
        path: 'language',
        loadComponent: () => import('./pages/language/language.component').then(m => m.LanguageComponent),
        title: 'Language Detection',
              canActivate: [memberGuard],
      },
      {
        path: 'research/goemotions',
        loadComponent: () => import('./pages/goemotions/goemotions.component').then(m => m.GoEmotionsComponent),
        title: 'GoEmotions Translation',
              canActivate: [adminGuard],
      },
      {
        path: 'admin/backups',
        loadComponent: () => import('./pages/backup-management/backup-management.component').then(m => m.BackupManagementComponent),
        title: 'Backup Management',
        canActivate: [superadminGuard],
      },
      {
        path: 'admin/users',
        loadComponent: () => import('./pages/users/users.component').then(m => m.UsersComponent),
        title: 'Manajemen Pengguna',
        canActivate: [adminGuard],
      },
      {
        path: 'admin/sessions',
        loadComponent: () => import('./pages/sessions/sessions.component').then(m => m.SessionsComponent),
        title: 'Audit Sesi Login',
        canActivate: [adminGuard],
      },
      {
        path: 'admin/backup-config',
        loadComponent: () => import('./pages/backup-config/backup-config.component').then(m => m.BackupConfigComponent),
        title: 'Backup Configuration',
        canActivate: [superadminGuard],
      },

    ],
  },
  { path: '**', redirectTo: 'research/dataset/overview' },
];
